<template>
<div class="main">
	<div class="banner" ref="case" @click="toBuy">
		<img src="../../images/dadi2026Banner2.png" alt="">
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="产品介绍" name="introduction"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">
			保障方案<br />
			<span class="planText">方案编码：CP37020026042402</span>
		</div>
		<div class="center">
			<a v-if="remark" :href="remark" target="_blank">（职业类别表查看）</a>
		</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<tbody>
						<tr>
							<th colspan="2">2026版</th>
							<th colspan="2">80万保额方案</th>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">年龄</td>
							<td>16-65</td>
							<td>65-70</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">死亡\伤残限额</td>
							<td>80万</td>
							<td>死亡20万\伤残0元</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">医疗限额</td>
							<td>20万</td>
							<td>0元</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加猝死责任保险（2026版）限额</td>
							<td>40万</td>
							<td>2万</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">非保安\保洁公司的 保安 \保洁人员猝死限额</td>
							<td>20万</td>
							<td>2万</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加上下班途中扩展保险（2026版）死亡/伤残限额</td>
							<td>40万</td>
							<td>2万</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加宿舍责任扩展保险（2026版）死亡/伤残限额</td>
							<td>20万</td>
							<td>2万</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加伤残等级赔偿比例调整保险（2026版E款）</td>
							<td colspan="2">同主险保额</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加雇员调整保险（2026版）</td>
							<td colspan="2">同主险保额</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加误工费用赔偿计算标准调整保险（2026版）</td>
							<td>160元/人/天</td>
							<td>0元</td>
						</tr>
						<tr class="hoverTr">
							<td colspan="2">附加特定区域或医院提前告知保险（2026版）</td>
							<td colspan="2">/</td>
						</tr>
					</tbody>
					<tbody class="hoverTr">
						<tr>
							<td rowspan="3">保费</td>
							<td>1-3类（不含保安）</td>
							<td colspan="2">24</td>
						</tr>
						<tr>
							<td>4类（不含保安）</td>
							<td colspan="2">46</td>
						</tr>
						<tr ref="introduction">
							<td>保安</td>
							<td colspan="2">27</td>
						</tr>
					</tbody>
					<tbody class="hoverTr">
						<tr>
							<td>免赔</td>
							<td colspan="3">1、医疗费用：每次事故绝对免赔额200元 。 2、误工费用：每次事故免赔天数3天，最高赔偿180天。</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div>
				<table class="productDetail-table">
					<thead>
						<tr>
							<th>特别约定和条款</th>
						</tr>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td>1.本保单仅承保与被保险人存在合法劳动\劳务关系、年龄在16 周岁至 70 周岁之间、职业类别为1—4 类的雇员。其中，4类（不含保安）职业人员投保数量不得超过本保单总投保人数的10%；年龄年满 65 周岁且未满 70 周岁的雇员，投保数量不得超过本保单总投保人数的5%。保险事故发生时，若被保雇员实际从事的职业类别高于保单约定承保的职业类别，或无法提供合法有效的劳动\劳务合同，保险人不承担保险责任，且不退还保险费。</td>
						</tr>
						<tr class="hoverTr">
							<td>2.本保单承保人员以保单所附《人员清单》为准，该清单须完整载明雇员身份信息及用工关系信息。投保人自愿将本保单项下全部投保人权益转让予本保单雇主责任险列明的被保险人，并全权授予被保险人行使本保单项下相应保险权益。本保单项下所有实际用工单位及委托投保人参保的单位均为共同被保险人，且实际用工单位仅限山东省内；若实际用工单位不在山东省内，或保险事故发生时出险雇员所在实际用工单位与投保时列明的实际用工单位不一致的，保险人不承担保险责任，且不退还保险费。</td>
						</tr>
						<tr class="hoverTr">
							<td>3.保险期限为月度的，承保期间内支持人员批增，不支持人员批退及替换；参保了其他雇主责任险或工伤险者，先由其他雇主责任险或工伤险赔付，本保单约定的工亡、伤残、医疗、误工费赔偿作为补充责任存在，本保单的赔偿限额与企业实际依法承担的赔偿金额，两者取低者赔付。</td>
						</tr>
						<tr class="hoverTr">
							<td>4.保险事故发生后，被保险人应于48 小时内报案（法定节假日顺延至工作日的首日及时报案）超时报案的保险人按核定金额的50%免赔。被保险人应积极履行出险通知义务，确保保险人及时核定事故。未能及时报案的，被保险人应提供出险时视频监控或其他有效证据，证明事故发生于工作时间、工作场所内。因报案超过48小时，导致保险事故的性质、原因、损失程度等难以确定，或造成损失扩大的，保险人对无法确定部分及损失扩大部分不承担赔偿责任。</td>
						</tr>
						<tr class="hoverTr">
							<td>5.本保单不予承保以下行业及相关从业人员：地质矿产业、航运业、渔业、钢结构行业、危险品制造业、建筑工程业、木材加工业、铸造业、锻造业、金属冶炼业、金属轧制业、钢/铁管生产业、道路运输业、道路清洁行业、快递配送业（不含该行业内未实际从事上门配送、外勤派送工作的人员）中的三类职业类别以上人员和公司名称含保安\保洁及同类字样的公司。若投保人、被保险人存在错投情形的，保险人对前述不予承保对象不承担任何保险赔偿责任，并按本保险单约定退保处理。 非交通事故的死亡案件须第一时间拨打报警电话。</td>
						</tr>
						<tr class="hoverTr">
							<td>6.本保单医疗费用及误工费赔付，仅限于中华人民共和国境内合法经营的二级以上（含二级）公立医院或保险人认可的其他医疗机构。因急诊在二级以下医保定点医疗机构治疗的，仅限出险当日1000元以下紧急救治费用，超出部分保险人不承担赔偿责任，（医疗费用赔付范围参照国家《工伤保险诊疗项目目录》《工伤保险药品目录》执行）。 已满65周岁至未满70周岁，医疗费用为0元。</td>
						</tr>
						<tr class="hoverTr">
							<td>7.误工费标准：已满16周岁至未满65周岁：住院期间160元/人/天，非住院期间100元/人/天，且以本保单约定标准与出险雇员实际工资两者较低者为准，累计赔付最长不超过180 天；已满65周岁至未满70周岁，误工费为0元。误工费与伤残赔偿金不可兼得。</td>
						</tr>
						<tr class="hoverTr">
							<td>8.被保险人雇员在工作时间和工作岗位突发疾病死亡，或在48 小时之内经抢救无效死亡，且经尸检报告确认非因既往症导致死亡的，属于本保单保险责任，按本保单《附加猝死责任保险（2026版）》限额赔偿。无法提供尸检报告，或出险雇员已达到法定退休年龄的，按本保单附加猝死责任限额的50%赔付，已满65周岁至未满70周岁人员猝死最高赔偿限额2万元。雇员因下列既往病症导致死亡或伤残的，保险人不承担赔偿责任：2 级及以上高血压（收缩压≥160mmHg 或舒张压≥101mmHg）、冠心病、心肌病、心肌梗死、风湿性心脏病、心瓣膜病、严重心律失常、心功能不全二级（含）以上、主动脉瘤、主动脉夹层、脑血管疾病、脑卒中。被保险人雇员因既往疾病、传染病、分娩、堕胎、流产及因此实施的内外科治疗导致伤、残或死亡的，保险人不承担赔偿责任。</td>
						</tr>
						<tr class="hoverTr">
							<td>9.本保单项下人员伤亡损失赔偿标准，依据《工伤保险条例》计算。被保险人雇员因属于工伤认定范围的交通事故或其他有责任方的侵权事故导致死亡、伤残的，本保单承担补充赔偿责任。死亡赔偿金依据《工伤保险条例》在保单每人人身伤亡责任限额内据实计算；伤残赔偿金依据《工伤保险条例》计算金额与保单伤残等级赔偿比例表计算金额两者以低者为准。涉及社会平均工资及本人工资计算的，参照上一年度全国城镇私营单位就业人员平均工资计算。保险人对每一被保险人每次事故赔偿限额为2,000,000元。</td>
						</tr>
						<tr class="hoverTr">
							<td>10.每人死亡、伤残赔偿金额以保单约定赔偿限额与被保险人依法应承担的赔偿金额两者较低者为准。<br />（1）未达退休年龄员工的伤残等级，按照GB/T 16180-2014《劳动能力鉴定职工工伤与职业病致残等级》鉴定。伤残赔偿金按保单最高伤残赔偿限额乘以对应伤残等级比例计算，且以保单限额与企业依法应承担金额两者较低者为准。如无法提供按照GB/T 16180-2014《劳动能力鉴定职工工伤与职业病致残等级》鉴定的意见书，保险人有权拒绝赔付。<br />（2）已达到法定退休年龄且未满65周岁员工的伤残等级，按照GB/T 16180-2014《人体损伤致残程度分级》鉴定，并按鉴定等级参照《工伤保险条例》仅赔付一次性伤残补助金。如无法提供按照GB/T 16180-2014《人体损伤致残程度分级》鉴定的意见书，保险人有权拒绝赔付。<br />（3）已满65周岁至未满70周岁的员工，不赔付伤残赔偿金。<br />（4）事故性质以保险人据实核定为准；对于未达退休年龄的员工发生涉及死亡、伤残及群体性事故的，须提供工伤认定书，否则保险人有权拒绝赔付。</td>
						</tr>
						<tr class="hoverTr">
							<td>11.被保险人雇员发生属于工伤认定范围的交通事故导致伤残的本保单承担补充赔偿责任存在，赔付标准在附加条款约定的伤亡责任限额与本保险条款附录《伤残等级赔偿比例表》中相应百分比乘积的赔偿限额内参照《工伤保险条例》计算，不属于工伤认定范围的交通事故不予赔付。<br />（1）若雇员从其他保险及侵权方获得赔偿金额之和大于等于本保单《附加上下班途中扩展保险（2026版）》条款中的保额对应伤残比例赔偿限额的，保险人不再赔付；<br />（2）若雇员从其他保险及侵权方获得赔偿金额之和小于本保单《附加上下班途中扩展保险（2026版）》条款中的保额对应伤残比例赔偿限额的，按事故责任比例设置免赔:同等责任免赔50%、次要责任70%无责任免赔85%。实际赔付金额按以下计算结果确定：<br />实际赔付金额=本保单《附加上下班途中扩展保险（2026版）》条款中的保额*(1-免赔率)。</td>
						</tr>
						<tr class="hoverTr">
							<td>12.被保险人雇员发生属于工伤认定范围的交通事故导致死亡的本保单承担补充赔偿责任存在，赔付标准在附加条款约定的伤亡责任限额内参照《工伤保险条例》计算，不属于工伤认定范围的交通事故不予赔付；按事故责任比例设置免赔:同等责任免赔50%、次要责任70%、无责任免赔85%。实际赔付金额按以下计算结果确定: <br />实际赔付金额=本保单《附加上下班途中扩展保险（2026版）》条款中的保额*(1-免赔率)。</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="detail-main-text left pt40"><b>产品条款查看：</b></div>
			<div style="font-size: 14px;text-align: left;padding-left: 20px;">
				<p ref="claim">
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加雇员调整保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加雇员调整保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9%EF%BC%882026%E7%89%88E%E6%AC%BE%EF%BC%89%E6%9D%A1%E6%AC%BE10%25.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加伤残等级赔偿比例调整保险（2026版E款）条款10%》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加上下班途中扩展保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加上下班途中扩展保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加宿舍责任扩展保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加宿舍责任扩展保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加特定区域或医院提前告知保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加特定区域或医院提前告知保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加误工费用赔偿计算标准调整保险（2026版）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加误工费用赔偿计算标准调整保险（2026版）条款》</a><br />
					<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/中国大地财产保险股份有限公司雇主责任保险附加猝死责任保险（2026版B款）条款.docx" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险附加猝死责任保险（2026版B款）条款》</a>
				</p>
			</div>
		</div>
	</div>
	<div class="detail">
			<div class="detail-title">理赔流程</div>
			<div class="detail-main">
				<div class="detail-main-text">
					<p>
						第一步，报案：发生事故后48小时内，拨打95590电话报案。<br />
						第二步，审核：根据指引提交理赔资料，保险公司将及时进行审核、调查，根据情况通知寄送纸质材料。<br />
						第三步，结案：资料提交齐全后，最晚将在30日内完成审核结案。<br />
						第四步，支付：对属于保险责任且资料齐全的，保险公司将在赔付协议达成后10日内支付赔款。
					</p>
				</div>
			</div>
			<br>
			<br>
		</div>
	<TrackNotice companyName="中国大地财产保险股份有限公司青岛分公司" />
</div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			tabName:'info',
			fixed:false,
			remark:'',
			version:''
		}
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	created(){
		// 获取职业类别表
		this.getJob()
	},
	methods:{
		// 立即购买
		toBuy() {
			// if(this.getTimeState()){
			// 	this.$Modal.warning({
			// 		title: '提示',
            //         content: '今日已超过购买时间，无法购买，请明日再进行购买'
            //     });
			// 	return false
			// }
			//2023.8.7增加回溯逻辑
			this.stopRecord({
				is_new: true
			}).then(()=>{
				this.$router.push(`/companyGroupEmployerDadi/fillin?productCode=CCIC_EMPLOYER_LIABILITY_M4&productName=人资雇主责任保险2026年产品2&version=${this.version}`)
			})
		},
		getTimeState(){
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 设置默认文字
			let state= false;
			// 判断当前时间段
			if (hours > 21 && hours <= 24) {
				state= true;
			}
			return state;
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		},
		async getJob(){
			await this.$axios.post('/broker/dict/find.json',{
				bizId:'INDUSTRY_ENTERPRISE',
				companyId: '10157',
				dictCode:'work_type',
				productCode: 'CCIC_EMPLOYER_LIABILITY_M4',
			}).then((res) => {
				this.remark = res.remark;
				this.version = res.version;
			})
		}
	}
}
</script>
<style scoped lang="less">
	.planText{
		color: #666;
		font-size: 16px !important;
	}
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 24px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }
	.productDetail-table{
		font-size: 14px !important;
		th{
			font-size: 16px !important;
			text-align: center;
		}
	}
    .productDetail-table .sm {
        font-size: 13px;
        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/indexCCIC_M4.vue